import { FlashTriangleOutlineIcon } from './FlashTriangleOutlineIcon';

/**
 * author: tetzla
 * id 825BA6A5-367F-42F8-A2B2-EBE84D7CBCF3
 * name flash-triangle-outline
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flash-triangle-outline.svg
 * tags
 * - Home Automation 
 */
export const HighVoltageOutlineIcon = FlashTriangleOutlineIcon;
export default HighVoltageOutlineIcon